import PinRedIcon from './component'

export default PinRedIcon
